(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countries-page"]) return;
  try {
    
  document.querySelectorAll('.country-link').forEach(
      (link) => {
          link.addEventListener(
              'click', (e) => {
                  e.preventDefault();
                  let country = link.dataset.country;
                  let lang = 'EN';

                  if (link.hasAttribute("data-lang")) {
                      lang = link.dataset.lang;
                  }

                  theme.updateLocalization(country, lang);
              }
          )
      }
  );

  } catch(e) { console.error(e); }
})();
})();
